import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MaterialGlobalModule, PtlFormsModule } from "@ptl/forms";
import { RequiredDocsUploadComponent } from "./required-docs-upload/required-docs-upload.component";
import { RequiredDocsUploadSpecialEnrollmentComponent } from "./required-docs-upload/variants/required-docs-upload-special-enrollment/required-docs-upload-special-enrollment.component";
import { DynamicDocsUploadSpecialEnrollmentComponent } from "./required-docs-upload/variants/dynamic-docs-upload-special-enrollment/dynamic-docs-upload-special-enrollment.component";
import { ByteFormatterPipe } from "./byte-formatter.pipe";
import { FileDisplayWithDropdownComponent } from "./file-display/variants/file-display-with-dropdown/file-display-with-dropdown.component";
import { FileDisplayComponent } from "./file-display/file-display.component";
import { FileDisplayWithModalComponent } from "./file-display/variants/file-display-with-modal/file-display-with-modal.component";
import { RequiredDocsUploadReviewComponent } from "./required-docs-upload-review/required-docs-upload-review.component";
import { RequiredDocsUploadFormComponent } from "./required-docs-upload-form.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { NgReduxFormModule } from "@ptl/angular-redux-form";

@NgModule({
  imports: [
    CommonModule,
    MaterialGlobalModule,
    FormsModule,
    PtlFormsModule,
    ReactiveFormsModule,
    NgReduxFormModule,
    MatSelectModule
  ],
  declarations: [ 
    RequiredDocsUploadComponent, 
    RequiredDocsUploadFormComponent, 
    RequiredDocsUploadSpecialEnrollmentComponent, 
    DynamicDocsUploadSpecialEnrollmentComponent, 
    FileDisplayComponent, 
    ByteFormatterPipe, 
    FileDisplayWithDropdownComponent, 
    FileDisplayWithModalComponent, 
    RequiredDocsUploadReviewComponent
  ],
  exports: [
    RequiredDocsUploadComponent,
    RequiredDocsUploadFormComponent,
    RequiredDocsUploadSpecialEnrollmentComponent,
    DynamicDocsUploadSpecialEnrollmentComponent,
    FileDisplayComponent,
    ByteFormatterPipe,
    FileDisplayWithDropdownComponent,
    FileDisplayWithModalComponent,
    RequiredDocsUploadReviewComponent
   ]
})
export class RequiredDocsUploadModule { }